import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { createHash } from 'crypto-pro';

import { BankType } from '../../pages/exchange/mock';
import ExchangeApi from '../../services/api/ExchangeApi';
import { RootState } from '../../types';
import { showError } from '../../utils/utils';

const setExchangeLoading = createAction<{
  type: 'exchange';
  value: boolean;
}>('setExchangeLoading/setExchangeLoading');

const setExchange = createAsyncThunk(
  'setExchangeLoading/setExchange',
  async (
    payload: {
      buy: string;
      sale: string;
      buyBank: BankType;
      saleBank: BankType;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(setExchangeLoading({ value: true, type: 'exchange' }));

      return payload;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(setExchangeLoading({ value: false, type: 'exchange' }));
    }
    return undefined;
  }
);

const getExchanges = createAsyncThunk(
  'setExchangeLoading/getExchanges',
  async (
    payload: {
      search?: string;
      period?: {
        from?: string;
        to?: string;
        direction?: 'ASC' | 'DESC';
      };
      isPublic?: boolean;
    },
    thunkAPI
  ) => {
    try {
      const store = thunkAPI.getState() as RootState;
      const { token, id: accountId } = store.auth.account;
      const response = await ExchangeApi.getExchanges(token, {
        ...payload,
        accountId,
      });
      if (response.status === 200) {
        return response.data;
      }
      return undefined;
    } catch (err) {
      showError(err, thunkAPI);
    }
  }
);

const getExchange = createAsyncThunk(
  'setExchangeLoading/getExchange',
  async (id: number, thunkAPI) => {
    try {
      const store = thunkAPI.getState() as RootState;
      const { token } = store.auth.account;
      const response = await ExchangeApi.getExchange(token, id);
      if (response.status === 200) {
        return response.data;
      }
      return undefined;
    } catch (err) {
      showError(err, thunkAPI);
    }
  }
);

const getExchangeAgreement = createAsyncThunk(
  'setExchangeLoading/getExchangeAgreement',
  async (
    payload: {
      id: number;
      signed: boolean;
    },
    thunkAPI
  ) => {
    try {
      const store = thunkAPI.getState() as RootState;
      const { token, id: accountId } = store.auth.account;
      const response = await ExchangeApi.getAgreement(token, {
        ...payload,
        accountId,
      });
      if (response.status === 200) {
        const bufferHash = await createHash(response.data);

        return {
          doc: btoa(String.fromCharCode(...new Uint8Array(response.data))),
          hash: bufferHash,
        };
      }
    } catch (err) {
      showError(err, thunkAPI);
    }
    return undefined;
  }
);

export {
  setExchangeLoading,
  setExchange,
  getExchanges,
  getExchangeAgreement,
  getExchange,
};
